import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";


export default function UtilisationKpiTable({i}){
	
	const thisContainer = {
		display:'flex',
		flexDirection:"column",
		flexGrow:"1",
		marginLeft:"20px",
		marginTop:"10px"
	};
	
	const redTable = {
		display:"flex",
		height:"30px",
		width:"230px",
		borderRadius:"15px",
		backgroundColor:"darkred",
		alignItems:"center",
		justifyContent:"space-between",
		boxShadow:'0 3px 6px rgba(0,0,0,0.18), 0 3px 6px rgba(0,0,0,0.18)'
	};
	
	const redTitle = {
		display:"flex",
		paddingLeft:"20px",
		color:"white",
		fontSize:'14px'
	};
	
	const redValue = {
		display:"flex",
		paddingRight:"20px",
		color:"white",
		fontSize:'14px',
		fontWeight:"bold"
	};
	
	const greyTable = {
		display:"flex",
		height:"30px",
		width:"230px",
		borderRadius:"15px",
		backgroundColor:"#eee",
		alignItems:"center",
		justifyContent:"space-between",
		marginTop:"7px"
	};
	
	const greyTitle = {
		display:"flex",
		paddingLeft:"20px",
		color:"black",
		fontSize:'14px'
	};
	
	const greyValue = {
		display:"flex",
		color:"black",
		fontSize:'14px',
		fontWeight:"bold",
		borderRadius:"15px",
		width:"60px",
		height:"100%",
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		boxShadow:'0 3px 6px rgba(0,0,0,0.18), 0 3px 6px rgba(0,0,0,0.18)'
	};
	
	return (
		<div style={thisContainer}>
			<div style={redTable}>
				<div style={redTitle}>
					Never used
				</div>
				<div style={redValue}>
					3
				</div>
			</div>
			<div style={greyTable}>
				<div style={greyTitle}>
					Average Capacity
				</div>
				<div style={{...greyValue, backgroundColor:'orange'}}>
					60%
				</div>
			</div>
			<div style={greyTable}>
				<div style={greyTitle}>
					Time Over 90% Cap
				</div>
				<div style={{...greyValue, backgroundColor:'green'}}>
					46%
				</div>
			</div>
			<div style={greyTable}>
				<div style={greyTitle}>
					Time Under 10% Cap
				</div>
				<div style={{...greyValue, backgroundColor:'red'}}>
					22%
				</div>
			</div>
		</div>
	);
}